import React from "react";
import { Marker as MapGLMarker } from "react-map-gl";

import { Typography } from "@material-ui/core";

//@ts-ignore
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
//@ts-ignore
import StopIcon from "@material-ui/icons/Stop";

import SimpleTooltip, { SimpleTooltipBackgroundColour, SimpleTooltipPlacement } from "components/SimpleTooltip";
import useColourPalette from "components/visuals/useColourPalette";

import { NearbyStore } from "modules/customer/tools/location/retailers/nearbyStore";
import { BrandClassification } from "domain/BrandClassification";

interface MarkerProps {
    nearbyStore: NearbyStore,
    zoomLevel: number,
    onTooltipOpen: () => void,
    onTooltipClose: () => void
}


const Marker: React.FC<MarkerProps> = (props) => {
    const { nearbyStore, zoomLevel, onTooltipOpen, onTooltipClose } = props;
    const colourPalette = useColourPalette();

    const defaultSizeTriangleMarkers = "24px";
    const defaultSizeOtherShapeMarkers = "20px";

    const iconStyle = (color: string, rotation?: number, borderColour?: string): React.CSSProperties => ({
        color,
        cursor: "pointer",
        ...(rotation ? { transform: `rotate(${rotation}deg)` } : {}),
        stroke: borderColour ?? "#000000",
        strokeWidth: 2
    });

    const calculateMarkerSize = (zoomLevel: number, defaultMarkerSize: string, isTriangle: boolean): string => {
        if (zoomLevel >= 16 && zoomLevel < 17) {
            return isTriangle ? "34px" : "30px";
        }
        else if (zoomLevel >= 17) {
            return isTriangle ? "42px" : "38px";
        }
        else {
            return defaultMarkerSize;
        }
    };

    const getNearbyStoreIcon = (classification: BrandClassification) => {
        switch (classification.name) {
            case "Luxury":
                return <StopIcon cursor="pointer" style={{ ...iconStyle(colourPalette.categorical[1], 45), fontSize: calculateMarkerSize(zoomLevel, defaultSizeOtherShapeMarkers, false) }} />;
            case "Premium":
                return <PlayArrowIcon cursor="pointer" style={{ ...iconStyle(colourPalette.categorical[0], 270), fontSize: calculateMarkerSize(zoomLevel, defaultSizeTriangleMarkers, true) }} />;
            case "Mainstream":
                return <StopIcon cursor="pointer" style={{ ...iconStyle(colourPalette.categorical[5]), fontSize: calculateMarkerSize(zoomLevel, defaultSizeOtherShapeMarkers, false) }} />;
            case "Value":
                return <PlayArrowIcon cursor="pointer" style={{ ...iconStyle("#FFE557", 90), fontSize: calculateMarkerSize(zoomLevel, defaultSizeTriangleMarkers, true) }} />;
            case "Budget":
                return <FiberManualRecordIcon cursor="pointer" style={{ ...iconStyle(colourPalette.categorical[4]), transform: "scale(0.85)", fontSize: calculateMarkerSize(zoomLevel, defaultSizeOtherShapeMarkers, false) }} />;
            default:
                return <StopIcon cursor="pointer" style={{ ...iconStyle("#000000", 0, "#9C9AA6"), transform: "scale(0.9)", fontSize: calculateMarkerSize(zoomLevel, defaultSizeOtherShapeMarkers, false) }} />;
        }
    };

    return (
        <MapGLMarker
            latitude={nearbyStore.latitude}
            longitude={nearbyStore.longitude}
            offsetTop={-10}
            offsetLeft={-12}
        >
            <SimpleTooltip
                placement={SimpleTooltipPlacement.Bottom}
                backgroundColour={SimpleTooltipBackgroundColour.Quaternary}
                onOpen={onTooltipOpen}
                onClose={onTooltipClose}
                title={
                    <Typography variant="body2" component="div" align="center" style={{ fontWeight: "bold" }}>
                        {nearbyStore.storeName}
                    </Typography>
                }
            >
                {getNearbyStoreIcon(nearbyStore.brandClassification)}
            </SimpleTooltip>
        </MapGLMarker>
    );
};

export default Marker;
